import React from 'react';
import { Shimmer, ShimmerElementType } from '@fluentui/react';

const rowElement = [{ type: ShimmerElementType.line, height: 43 }];
const mapElement = [{ type: ShimmerElementType.line, height: 240 }];

export function TableShimmer() {
  return (
    <div className="table-shimmer-container">
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 5 }} />
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 5 }} />
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 5 }} />
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 5 }} />
      <Shimmer shimmerElements={rowElement} style={{ marginBottom: 5 }} />
    </div >
  );
}

export function MapShimmer() {
  return (
    <div className="map-shimmer-container">
      <Shimmer shimmerElements={mapElement} style={{ marginBottom: 5 }} />
    </div >
  );
}
